<template>
  <div id="workflow-variety-box">
    <v-layout justify-center row v-if="workflowRecords.length > 0" wrap>
      <v-flex sm6 xs11>
        <div class="font-weight-bold headline head-page">
          <slot>วิธีการปลูก</slot>
        </div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex pt-0 sm6 xs11>
        <v-layout
          class="mouse-pointer"
          @click="onClickWorkflow(workflowRecord.idx, workflowRecord.title)"
          justify-center
          :key="index"
          row
          v-for="(workflowRecord, index) in workflowRecords.slice(0, limit)"
          wrap
        >
          <v-flex px-0 xs2>
            <v-img
              :aspect-ratio="4 / 4"
              class="grey lighten-2"
              cover
              :lazy-src="require('@/assets/NoPicture.png')"
              :src="
                workflowRecord.picture ? workflowRecord.picture : require('@/assets/NoPicture.png')
              "
            >
              <template v-slot:placeholder>
                <v-layout align-center fill-height justify-center ma-0>
                  <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-flex>
          <v-flex xs9>
            <div class="body-2 font-weight-bold">{{ workflowRecord.title }}</div>
            <div class="workflow-desc mt-1">{{ workflowRecord.description }}</div>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex v-if="workflowRecords.length - 2 > 0" xs11>
        <v-hover>
          <v-card
            :class="`mouse-pointer elevation-${hover ? 4 : 0}`"
            color="grey lighten-3"
            slot-scope="{ hover }"
          >
            <v-card-title class="py-2">
              <v-layout align-center fill-height justify-center ma-0>
                <v-flex pa-0 text-xs-center xs12>
                  <div class="body-1 grey--text">{{ `ดูวิธีปลูกอื่นๆ` }}</div>
                  <div class="headline head-page">{{ `+${workflowRecords.length - 2}` }}</div>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-hover>
      </v-flex>-->
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'workflow-variety-box',
  props: {
    limit: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {}
  },
  computed: {
    workflowRecordId() {
      return this.$route.params.workflowRecordId
        ? window.atob(this.$route.params.workflowRecordId)
        : null
    },
    productId() {
      return window.atob(this.$route.params.productId)
    },
    varietyId() {
      return window.atob(this.$route.params.varietyId)
    },
    workflowRecords() {
      if (this.workflowRecordId) {
        return this.$store.getters['Workflow/getWorkflowRecords'].filter(
          item => item.idx != this.workflowRecordId
        )
      } else {
        return this.$store.getters['Workflow/getWorkflowRecords'].filter(
          item => item.varietyId == this.varietyId
        )
      }
    }
  },
  created() {
    this.$store.dispatch('Workflow/fetchWorkflowRecord', this.productId)
  },
  methods: {
    onClickWorkflow(worflowRecordId) {
      this.$router.push({
        name: 'workflow',
        params: {
          productId: window.btoa(this.productId),
          workflowRecordId: window.btoa(worflowRecordId)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.workflow-desc {
  font-size: 9px;
  display: -webkit-box;
  max-width: 100%;
  height: 27px;
  margin: 0 auto;
  line-height: 1.5em;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
